export default class ConversationsClient {
    constructor(apiClient) {
        this.conversationsUrl = '/v3/conversations';
        this.apiClient = apiClient;
        this.getConversation = this.getConversation.bind(this);
        this.getMessages = this.getMessages.bind(this);
        this.getParticipants = this.getParticipants.bind(this);
        this.postMessage = this.postMessage.bind(this);
        this.putConversationDismiss = this.putConversationDismiss.bind(this);
        this.putConversationRead = this.putConversationRead.bind(this);
        this.putConversationUnread = this.putConversationUnread.bind(this);
        this.getAssignedConversations = this.getAssignedConversations.bind(this);
        this.getParticipatingConversations = this.getParticipatingConversations.bind(this);
        this.postConversationSearches = this.postConversationSearches.bind(this);
        this.addConversationPeople = this.addConversationPeople.bind(this);
        this.removeConversationPeople = this.removeConversationPeople.bind(this);
    }
    getConversation(conversationId, config) {
        return this.apiClient.get(`${this.conversationsUrl}/${conversationId}`, config);
    }
    getMessages(conversationId, config) {
        return this.apiClient.get(`${this.conversationsUrl}/${conversationId}/messages`, config);
    }
    getParticipants(conversationId, config) {
        return this.apiClient.get(`${this.conversationsUrl}/${conversationId}/participants`, config);
    }
    postMessage(conversationId, data, config) {
        return this.apiClient.post(`${this.conversationsUrl}/${conversationId}/messages`, data, config);
    }
    putConversationDismiss(conversationId, config) {
        return this.apiClient.put(`${this.conversationsUrl}/${conversationId}/dismiss`, null, config);
    }
    putConversationRead(conversationId, config) {
        return this.apiClient.put(`${this.conversationsUrl}/${conversationId}/read`, null, config);
    }
    putConversationUnread(conversationId, config) {
        return this.apiClient.put(`${this.conversationsUrl}/${conversationId}/unread`, null, config);
    }
    // getAssignedConversations retrieves a list of conversations assigned to the current user,
    // enriched with additional trip details such as destinations, request status, and match status.
    //
    // Query Parameters:
    //   - hasNewOnly: (optional) true to filter conversations with new messages only, false by default.
    //   - conversationType: (optional) filter by conversation type (e.g., TravelerToZicasso, TravelerToPartner, ZicassoToPartner).
    //   - travelerTag: (optional) filter by traveler tag (e.g., VIP, Repeat, All).
    //   - sort: (optional) direction to sort by FirstUnreadAt timestamp, "asc" (oldest first) or "desc" (newest first). Defaults to "asc".
    getAssignedConversations(config) {
        return this.apiClient.get(`${this.conversationsUrl}/assigned`, config);
    }
    // getParticipatingConversations returns a list of conversations assigned to the current user.
    //
    // Query parameters:
    //   - hasNewOnly = true, false (default)
    //   - limit = how many results per page to return
    //   - page = which page of results to return
    getParticipatingConversations(config) {
        return this.apiClient.get(`${this.conversationsUrl}/active`, config);
    }
    postConversationSearches(data, config) {
        return this.apiClient.post('/v3/conversation_searches', data, config);
    }
    addConversationPeople(conversationId, personIds, config) {
        return this.apiClient.post(`${this.conversationsUrl}/${conversationId}/people/${personIds.join(',')}`, null, config);
    }
    removeConversationPeople(conversationId, personIds, config) {
        return this.apiClient.delete(`${this.conversationsUrl}/${conversationId}/people/${personIds.join(',')}`, config);
    }
}
